import { Descriptions } from 'antd';
import React from 'react';
import { ApplicantUserPersonalInformation } from '../../../../generated';
import { ProfileHeaderContainer } from './profile-header.container';

const TITLE = 'Applying to Details';

export interface ApplicantProfileApplyToViewProps {
  data: ApplicantUserPersonalInformation;
  onEditToggle: () => void;
}

export const ApplicantProfileApplyToView: React.FC<ApplicantProfileApplyToViewProps> = (props) => {
  return (
    <div>
      <ProfileHeaderContainer title={TITLE} onEdit={props.onEditToggle} />
      <Descriptions title="Organizations to where I'm applying" layout="vertical" size="small" column={1} className="w-[410px] pl-8">
        {props.data.applyingTo?.map((applyingToEntity, index) => (
          <Descriptions.Item label={index === 0 ? 'Sent To' : undefined} key={applyingToEntity?.id} labelStyle={{marginBottom:"8px"}}>
            {applyingToEntity?.entityName}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};
